import React from 'react';
export function PainPoints() {
  return <section className="bg-black text-white py-16 px-4 md:px-8" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-8 text-yellow-400" data-id="element-103">
          Si sos maestra de Ciencias Sociales, esto te va a sonar familiar…
        </h2>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-200" data-id="element-104">
          <p data-id="element-105">
            Llegás del colegio agotada y todavía tenés que planificar. Horas
            buscando actividades sobre historia, geografía, ciudadanía,
            efemérides, mapas, líneas de tiempo, proyectos…
          </p>
          <p data-id="element-106">
            Armando secuencias didácticas desde cero, preparando evaluaciones
            claras, tratando de que los contenidos realmente enganchen a tus
            alumnos…
          </p>

          <div className="bg-gray-900 p-6 rounded-lg border border-gray-700 mt-8" data-id="element-107">
            <p className="font-bold text-center text-xl md:text-2xl text-white" data-id="element-108">
              No es falta de capacidad. <br data-id="element-109" />
              <span className="text-red-400" data-id="element-110">
                Es que te falta un sistema integral que te sostenga todo el año
                escolar.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}